<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar :ifCanBack="false" title="支付结果">
      </black-bar>
    </div>
    <img :src="waiting"
         alt=""
         style="margin-top:4vh">
    <p>正在处理</p>
    <p class="result">正在查询本次支付结果</p>
    <!-- <div class="btn">确认</div> -->

  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
export default {
  name: 'paySuccess',
  data () {
    return {
      waiting: require('../assets/img/icon_waiting.png'),
      success: require('../assets/img/noAccess/icon_success.png'),
      fail: require('../assets/img/noAccess/icon_fail.png'),
      loading: true,
      num: 20,
    }
  },
  components: {
    blackBar
  },
  created () {

  },
  methods: {
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
p {
  font-size: 40px;
  font-weight: 500;
  color: #333333;
  margin-top: 24px;
}
.result {
  font-size: 26px;
  color: #666666;
}
img {
  width: 100px;
  height: 100px;
}
.line {
  width: 92%;
  margin-left: 4%;
  border: 1px dashed #999999;
  margin-top: 60px;
}

.btn {
  position: absolute;
  left: 0;
  bottom: 80px;
  width: 92%;
  margin-left: 4%;
  height: 98px;
  line-height: 98px;
  background: #4a8ef7;
  box-shadow: 0px 6px 20px 1px rgba(63, 138, 247, 0.2);
  border-radius: 49px 49px 49px 49px;
  font-size: 32px;
  font-weight: 400;
  color: #ffffff;
}
</style>
